module.exports = __webpack_public_path__ + "img/icone-operador.da83dc72.svg";